import PhoneNumber from 'awesome-phonenumber';

export const extractPhoneNumber = (phoneNumber: string | null | undefined) => {
    if (!phoneNumber) return { countryCode: '', phoneNumber: '' };
    const phone = new PhoneNumber(phoneNumber);

    return {
        countryCode: `+${phone.getCountryCode().toString()}`,
        phoneNumber: phone.getNumber('significant'),
    };
};

export const getFormattedPhoneNumber = (phoneNumber: string | null | undefined) => {
    if (!phoneNumber) {
        return undefined;
    }

    const phone = new PhoneNumber(phoneNumber);

    if (!phone.isValid()) {
        console.error('Invalid phone number');
        return undefined;
    }

    return phone.getNumber('international');
};
